<div id="quizContainer" class="quiz-container" *ngFor="let entry of questionEntries">
    <question class="question-wrapper" *ngIf="currentQuestionEntry === entry" [questionEntry]="entry"
        (autoClose)="questionAutoClose(entry)" (userClose)="questionCloseCompletely(entry)"
        (correct)="questionCorrect(entry)" (incorrect)="questionIncorrect(entry)"></question>
</div>